export default __webpack_public_path__ + "static/media/Not-Found-another-bg.66432df8.PNG";